import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ScrollAnimation from "../../hooks/ScrollAnimation";

const FormCard = ({ form, index }) => {
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  const currentLang = lang || i18n.language || 'en';

  return (
    <ScrollAnimation direction="up" delay={index * 0.05}>
      <div onClick={() => navigate(`/${currentLang}/forms/${form.code}`)} className="bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md p-4 cursor-pointer transition-all">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-gray-900">{form.name}</h3>
            <p className="text-xs text-gray-500 mt-1">{t("forms.card.code", { code: form.code })}</p>
            <div className="mt-1">
              {form.is_paid ? (
                <span className="text-[10px] font-bold bg-green-100 text-green-700 px-2 py-0.5 rounded-full uppercase">
                  {t("forms.card.paid")}
                </span>
              ) : (
                form.price !== "0.00" && (
                  <p className="text-xs font-semibold text-blue-600">${form.price}</p>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </ScrollAnimation>
  );
};

export default FormCard;